import R from 'ramda'

export default (prop, fn) => selection => {
  return fn(R.map(R.prop(prop), selection))
}
  



/** WEBPACK FOOTER **
 ** ./app/utils/selectionProps.js
 **/